const creditNoteIncludes = [
    'sl_detail_sale_credit_notes.wh_product',
    'sl_service_order.sl_sale_ticket_affected',
    'sl_service_order.sl_sale_invoice_affected',
    'sl_customer',
    'sl_customer_branch_offices',
]

const ticketIncludes = [
    'first_pos_sale.g_seller_user.hr_employee',
    'first_pos_sale.g_cashier_user.hr_employee',
    'first_pos_sale.pos_cash_desk.g_branch_office',
]

const invoiceIncludes = [
    'first_pos_sale.g_seller_user.hr_employee',
    'first_pos_sale.g_cashier_user.hr_employee',
    'sl_customer',
    'sl_customer_branch_offices',
    'first_pos_sale.pos_cash_desk.g_branch_office',
]

export { creditNoteIncludes, ticketIncludes, invoiceIncludes }
